import React, { RefObject, ComponentProps, useRef, forwardRef, useImperativeHandle } from 'react'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import DropdownSheet from 'LuxKit/Dropdown/Sheet/DropdownSheet'

import CruiseLocationDesktopInput, { CruiseLocationDesktopInputRef } from './CruiseLocationDesktopInput'
import CruiseLocationMobileInput from './CruiseLocationMobileInput'

export interface CruiseLocationFilterRef {
  focus: () => void
}

interface Props {
  onChange: (values: App.CruiseGlobalFilters) => void
  isChipMode?: boolean
  /** Use when this component is inside a drawer modal */
  drawerMode?: boolean
  hideImages?: boolean
  dropdownAnchorRef?: RefObject<HTMLElement | null>
  dropdownSize?: ComponentProps<typeof DropdownSheet>['size']
  hideTrendOptions?: boolean
  initialFilters?: App.CruiseInitialFilters
  shouldIgnoreFlashOffers?: boolean
}

const CruiseLocationFilter = forwardRef<CruiseLocationFilterRef, Props>(({
  isChipMode,
  drawerMode,
  onChange,
  dropdownAnchorRef,
  dropdownSize,
  hideImages,
  initialFilters,
  hideTrendOptions,
  shouldIgnoreFlashOffers,
}, ref) => {
  const inputRef = useRef<HTMLDivElement>(null)
  const desktopInputRef = useRef<CruiseLocationDesktopInputRef>(null)

  useImperativeHandle(ref, () => ({
    focus: () => {
      desktopInputRef.current?.focus()
    },
  }), [])

  return <div ref={inputRef}>
    <CSSBreakpoint min="tablet">
      {drawerMode && <CruiseLocationMobileInput
        isChipMode={isChipMode}
        onChange={onChange}
        hideImages={hideImages}
        hideTrendOptions={hideTrendOptions}
        initialFilters={initialFilters}
        shouldIgnoreFlashOffers={shouldIgnoreFlashOffers}
      />}

      {!drawerMode && <CruiseLocationDesktopInput
        ref={desktopInputRef}
        dropdownAnchorRef={dropdownAnchorRef || inputRef}
        onChange={onChange}
        isChipMode={isChipMode}
        dropdownSize={dropdownSize}
        hideImages={hideImages}
        initialFilters={initialFilters}
        hideTrendOptions={hideTrendOptions}
        shouldIgnoreFlashOffers={shouldIgnoreFlashOffers}
      />}
    </CSSBreakpoint>
    <CSSBreakpoint max="mobile">
      <CruiseLocationMobileInput
        isChipMode={isChipMode}
        onChange={onChange}
        hideImages={hideImages}
        hideTrendOptions={hideTrendOptions}
        initialFilters={initialFilters}
        shouldIgnoreFlashOffers={shouldIgnoreFlashOffers}
      />
    </CSSBreakpoint>
  </div>
})

CruiseLocationFilter.displayName = 'CruiseLocationFilter'

export default CruiseLocationFilter
